import OrbitAvatar from '@/components/OrbitAvatar'
import OSlateEditor from '@/libs/slate-editor'
import { editTask } from '@/services/task/task'
import { EllipsisOutlined } from '@ant-design/icons'
import { Card, Dropdown, Menu, Button, Row } from 'antd'
import { Comment } from '@ant-design/compatible'
import dayjs from 'dayjs'
import { memo, useState } from 'react'
import styles from './index.module.less'

const noDescription = '[{"type":"paragraph","children":[{"text":"No description provided."}]}]'

const TaskDescription = memo((props: any) => {
  const { task, onSuccess } = props
  const [editing, setEditing] = useState(false)
  const [loading, setLoading] = useState(false)
  const [description, setDescription] = useState(task.description)

  return (
    <div className={styles.description}>
      <h5>Description</h5>
      <Comment
        avatar={<OrbitAvatar avatar={task.creator?.avatar} name={task.creator?.fullName} />}
        content={
          <Card
            title={
              <span>
                <strong>{task.creator?.fullName}</strong> commented {dayjs(task.createTime).fromNow()}
              </span>
            }
            size='small'
            extra={
              <Dropdown
                overlay={
                  <Menu
                    onClick={({ key }) => {
                      if (key === 'edit') {
                        setEditing(true)
                      }
                    }}
                    items={[{ key: 'edit', label: 'Edit' }]}
                  />
                }
              >
                <EllipsisOutlined />
              </Dropdown>
            }
          >
            {editing ? (
              <div>
                <OSlateEditor
                  value={description}
                  onChange={(value) => {
                    setDescription(value)
                  }}
                />
                <Row justify={'end'} className={'mt-1'}>
                  <Button
                    onClick={() => {
                      setEditing(false)
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={'ml-1'}
                    type='primary'
                    loading={loading}
                    onClick={async () => {
                      setLoading(true)
                      try {
                        const data = await editTask(task.id, { description })
                        setEditing(false)
                        onSuccess?.(data)
                      } finally {
                        setLoading(false)
                      }
                    }}
                  >
                    Save
                  </Button>
                </Row>
              </div>
            ) : (
              <OSlateEditor key={task.description} value={task.description || noDescription} readOnly={true} />
            )}
          </Card>
        }
      />
    </div>
  )
})

export default TaskDescription
